import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '../../../hooks/useAuth';
import Radio from '../../../components/Radio';
import { DatePicker, Table, TableColumnsType } from 'antd';
import moment, { Moment } from 'moment/moment';
import CustomTimePicker from '../../../components/CustomTimePicker';
import Button from '../../../components/Button';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import useAxios from '../../../hooks/useAxios';
import { IGetTemplates, ITemplate } from '../../../models/template.model';
import { deleteTemplate, getTemplates } from '../../../api/template.api';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import config from '../../../lib/config';
import { useHistory } from 'react-router-dom';
import Pagination from '../../../components/Pagination';
import styled from 'styled-components';
import {
  IGeneralMessageCustomer,
  IGeneralMessageReq,
} from '../../../models/pushMessage.model';
import useNotification from '../../../hooks/useNotification';
import UploadGeneralExcelModal from '../../../components/sms/send/modals/UploadGeneralExcelModal';
import EditTemplateModal from '../../../components/sms/send/modals/EditTemplateModal';
import { sendGeneralMessages } from '../../../api/pushMessage.api';
import { phoneValidation } from '../../../lib/util';
import { setCustomers as setStoreCustomers } from '../../../store/pushMessage.slice';
import ConfirmModal from '../../../components/sms/send/modals/ConfirmModal';

const Block = styled.div`
  .ant-table-wrapper {
    margin-top: 0;
  }

  .table-wrapper {
    margin-top: -20px;
  }
`;

const WriteMessage: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const { content, customers: storeCustomers } = useSelector(
    (root: RootState) => root.pushMessage,
  );
  const { infoNotification, successNotification } = useNotification();
  const { writeAuthYn } = useAuth();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { data: res, isLoading, error, execute } = useAxios<IGetTemplates>();
  const {
    data: deleteRes,
    isLoading: deleteIsLoading,
    error: deleteError,
    execute: deleteExecute,
  } = useAxios();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();
  const GeneralMessageHead = `[${t('sms.send.text2')}] `;
  const AdvertiseMessageHead = `[${t('student.student.option21')}] `;

  const [page, setPage] = useState(1);
  const [sendType, setSendType] = useState('GE');
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState(content || GeneralMessageHead);
  const [sendTimeDiv, setSendTimeDiv] = useState('IM');
  const [sendDate, setSendDate] = useState('');
  const [outgoingNumber, setOutgoingNumber] = useState('');
  const [editTemplateVisible, setEditTemplateVisible] = useState(false);
  const [template, setTemplate] = useState<ITemplate>();
  const [sendTime, setSendTime] = useState('');
  const [customers, setCustomers] =
    useState<IGeneralMessageCustomer[]>(storeCustomers);
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [visible, setVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);

  const columns: TableColumnsType<any> = [
    {
      title: t('common.column.title'),
      dataIndex: 'title',
      key: 'title',
      align: 'center',
      sorter: (a, b) => a.title?.localeCompare(b.title),
    },
    {
      title: t('common.column.contents'),
      dataIndex: 'content',
      key: 'content',
      align: 'center',
      sorter: (a, b) => a.content?.localeCompare(b.content),
      render: (value) =>
        value.length > 45 ? `${value.substring(0, 45)}...` : value,
    },
    {
      title: t('sms.list.column2'),
      key: 'sendType',
      dataIndex: 'sendType',
      align: 'center',
      sorter: (a, b) => a.sendType?.localeCompare(b.sendType),
      render: (value) => {
        switch (value) {
          case 'GE':
            return t('student.student.option20');
          case 'AD':
            return t('student.student.option21');
          default:
            return value;
        }
      },
    },
    {
      title: '',
      dataIndex: 'templateCode',
      key: 'templateCode',
      align: 'center',
      width: '160px',
      render: (value, record) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className="btn-basic small gray"
            onClickCapture={(e) => {
              e.stopPropagation();
              onDeleteTemplate(value);
            }}
            text={t('common.button.delete')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            className="btn-basic small mint"
            onClickCapture={(e) => {
              e.stopPropagation();
              onApplyTemplate(record);
            }}
            text={t('common.button.select')}
          />
        </div>
      ),
    },
  ];

  const CustomerColumns: TableColumnsType<IGeneralMessageCustomer> = [
    {
      title: 'No',
      align: 'center',
      render: (value, record, index) => index + 1,
    },
    {
      title: t('student.student.placeholder1'),
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
    },
    {
      title: t('sms.list.column18'),
      dataIndex: 'name',
      key: 'name',
      align: 'center',
    },
    {
      title: t('common.button.delete'),
      align: 'center',
      render: (value, record, index) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className="btn-basic small gray"
            text={t('common.button.delete')}
            writeAuthYn={writeAuthYn}
            onClick={() => onCustomerDelete(index)}
          />
        </div>
      ),
    },
  ];

  const onCustomerDelete = (index: number) => {
    const _customers = customers.filter(
      (value, customerIndex) => index !== customerIndex,
    );
    setCustomers(_customers);
  };
  const doGetTemplates = () => execute(getTemplates());

  const onSubmit = () => {
    const campus = campusData.find(
      ({ campusCode }) => campusCode === currentCampus,
    );
    if (!campus) return;
    if (!message) {
      return infoNotification(t('sms.send.message2'));
    }
    if (sendTimeDiv === 'RE' && (!sendDate || !sendTime)) {
      return infoNotification(t('sms.send.message3'));
    }
    if (!outgoingNumber) {
      return infoNotification(t('sms.send.message4'));
    }
    if (customers.length === 0) {
      return infoNotification(t('sms.list.message3'));
    }

    const req: IGeneralMessageReq = {
      campusCode: currentCampus,
      content: message,
      sendType,
      sendTimeDiv,
      customers,
      outgoingNumber,
    };
    if (title) {
      req.title = title;
    }
    if (sendTimeDiv === 'RE') {
      req.reservedTime = `${sendDate} ${sendTime}:00`;
    }

    submitExecute(sendGeneralMessages(req));
  };

  const onDeleteTemplate = (templateCode: number) => {
    deleteExecute(deleteTemplate(templateCode));
  };

  const onApplyTemplate = (template: ITemplate) => {
    setSendType(template.sendType);
    setTitle(template.title);
    setMessage(
      (template.sendType === 'GE' ? GeneralMessageHead : AdvertiseMessageHead) +
        template.content,
    );
  };

  const onCustomerRegister = () => {
    if (!phone) {
      return infoNotification(t('system.school.message3'));
    }
    if (!phoneValidation(phone)) {
      return infoNotification(t('sms.list.message4'));
    }
    if (customers.map(({ phone }) => phone).includes(phone)) {
      return infoNotification(t('sms.list.message5'));
    }
    setCustomers([...customers, { phone, name }]);
    setPhone('');
    setName('');
  };

  useEffect(() => {
    doGetTemplates();

    return () => {
      dispatch(
        setStoreCustomers({
          content: '',
          customers: [],
        }),
      );
    };
  }, []);

  useEffect(() => {
    const campus = campusData.find((item) => item.campusCode === currentCampus);
    if (campus) setOutgoingNumber(campus.telephoneNo);
  }, [currentCampus]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(
        `${
          sendTimeDiv === 'RE'
            ? t('sms.send.message1')
            : t('student.student.message46')
        }`,
      );
      history.push('/sms/nonmember');
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (deleteRes && !deleteIsLoading) {
      doGetTemplates();
      successNotification(t('common.message.delete'));
    }
  }, [deleteRes, deleteIsLoading]);

  const disabledDate = (date: Moment) => {
    return date.isBefore(moment(new Date()).subtract(1, 'days'));
  };
  const disabledHours = () => {
    const currentDate = moment(new Date());
    const hourArray = Array.from({ length: 24 }, (v, k) => k);
    if (sendDate === currentDate.format('YYYY-MM-DD')) {
      return hourArray.filter((v) => v < currentDate.hour());
    } else {
      return [];
    }
  };

  const showConfirmModal = () => setConfirmVisible(true);

  const closeConfirmModal = () => setConfirmVisible(false);

  return (
    <div className="content scrollbar">
      <SimpleHeader
        iconFile="icon-sms-big.svg"
        parentMenu={t('sms.list.title4')}
        currentMenu={t('sms.list.title5')}
      />
      <Block>
        {isLoading ? <Loader /> : null}
        <ErrorResponse error={error} />
        <ErrorResponse error={submitError} />
        <ErrorResponse error={deleteError} />
        <div className="row">
          {/* left side */}
          <div className="col-5">
            <div className='comm-table__area rowType mt-0'>
              <table>
                <colgroup>
                  <col width="20%" />
                  <col width="80%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th className="text-center" colSpan={2}>
                      {t('student.student.column57')}
                    </th>
                  </tr>
                  <tr>
                    <th className="text-center">{t('sms.list.column2')}</th>
                    <td>
                      <Radio
                        checked={sendType === 'GE'}
                        onChange={() => {
                          setSendType('GE');
                          setMessage(GeneralMessageHead);
                        }}
                        text={t('student.student.option20')}
                      />
                      <Radio
                        className="ml-4"
                        checked={sendType === 'AD'}
                        onChange={() => {
                          setSendType('AD');
                          setMessage(AdvertiseMessageHead);
                        }}
                        text={t('student.student.option21')}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-center">{t('common.column.title')}</th>
                    <td>
                      <input
                        type="text"
                        className="form-control input-text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-center">{t('common.column.contents')}</th>
                    <td>
                      <textarea
                        className="w-100"
                        rows={5}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                      <p className="mt-3">{t('sms.list.text1')}</p>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-center">{t('sms.list.column3')}</th>
                    <td>
                      <div className='comm-gap'>
                        <div>
                          <Radio
                            checked={sendTimeDiv === 'IM'}
                            onChange={() => setSendTimeDiv('IM')}
                            text={t('student.student.option22')}
                          />
                          <Radio
                            className="ml-4"
                            checked={sendTimeDiv === 'RE'}
                            onChange={() => setSendTimeDiv('RE')}
                            text={t('student.student.option23')}
                          />
                        </div>
                        <div className="date-picker__area">
                          <DatePicker
                            className="w-120p ml-1"
                            value={sendDate ? moment(sendDate) : undefined}
                            onChange={(e) => {
                              if (e === null) setSendDate('');
                              else setSendDate(moment(e).format('YYYY-MM-DD'));
                            }}
                            disabled={sendTimeDiv !== 'RE'}
                            disabledDate={disabledDate}
                          />
                        </div>
                        <div className="time-picker__area">
                          <CustomTimePicker
                            value={sendTime}
                            onSelect={(value) => {
                              if (value) setSendTime(moment(value).format('HH:mm'));
                              else setSendTime('');
                            }}
                            disabledHours={disabledHours}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-center">{t('sms.send.column2')}</th>
                    <td>
                      <input
                        type="text"
                        className="form-control input-text"
                        placeholder={t('sms.list.placeholder2')}
                        value={outgoingNumber}
                        onChange={(e) => setOutgoingNumber(e.target.value)}
                        disabled
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className='comm-bx__space'>
              <div className='flex comm-gap' style={{justifyContent:'right'}}>
                <input
                  type="text"
                  className="form-control input-text w-120p"
                  value={phone}
                  placeholder={t('student.student.placeholder1')}
                  onChange={(e) => setPhone(e.target.value)}
                />
                <input
                  type="text"
                  className="form-control input-text w-100p"
                  value={name}
                  placeholder={t('sms.list.column18')}
                  onChange={(e) => setName(e.target.value)}
                />
                <div className="comm-btn__area right">                
                  <Button
                    className="btn-basic pink"
                    onClick={onCustomerRegister}
                    text={t('common.button.register')}
                    writeAuthYn={writeAuthYn}
                  />
                  <Button
                    className="btn-basic pink-line"
                    onClick={() => setVisible(true)}
                    text={t('sms.send.button2')}
                    writeAuthYn={writeAuthYn}
                  />
              </div>
              </div>
            </div>
            <div className='comm-table__area'>
              <Table
                columns={CustomerColumns}
                dataSource={customers}
                pagination={false}
              />
            </div>
            <div className='comm-bx__space'>
              <div className="comm-btn__area right">
                <Button
                  className="btn-basic pink-line"
                  onClick={showConfirmModal}
                  text={t('student.student.button24')}
                  writeAuthYn={writeAuthYn}
                />
              </div>
            </div>
          </div>

          {/* right side */}
          <div className="col-7">
            <div className="comm-table__area mt-0">
              <Table
                columns={columns}
                dataSource={res?.data}
                pagination={{
                  current: page,
                  pageSize: config.smallPageSize,
                }}
                onRow={(record) => {
                  return {
                    onClick: () => {
                      setTemplate(record);
                      setEditTemplateVisible(true);
                    },
                  };
                }}
                rowClassName="pointer"
                rowKey="messageCode"
              />
            </div>
            <div className="comm-bx__between">
              <div />
              <div className='common-paging center'>
                <Pagination
                  count={res?.data.length || 0}
                  page={page}
                  setPage={setPage}
                />
              </div>
              <div className="comm-btn__area right">
                <Button
                  className="btn-basic pink-line"
                  onClick={() => setEditTemplateVisible(true)}
                  text={t('sms.send.button4')}
                  writeAuthYn={writeAuthYn}
                />
              </div>
            </div>
          </div>
        </div>
        {editTemplateVisible && (
          <EditTemplateModal
            visible={editTemplateVisible}
            setVisible={setEditTemplateVisible}
            doGetTemplates={doGetTemplates}
            template={template}
            setTemplate={setTemplate}
          />
        )}
      </Block>
      {visible && (
        <UploadGeneralExcelModal
          visible={visible}
          setVisible={setVisible}
          setCustomers={setCustomers}
        />
      )}
      {confirmVisible && (
        <ConfirmModal
          visible={confirmVisible}
          setVisible={setConfirmVisible}
          onCancel={closeConfirmModal}
          onOk={onSubmit}
        />
      )}
    </div>
  );
};
export default WriteMessage;
